import { Col, Row, message, Typography, Divider } from "antd";
import React, { useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOneUser, updateUser } from "redux/features/user";
import { useHistory } from "react-router-dom";

export const SETTINGS = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(true);

  console.log("user: ", user?.role);

  const onFinish = (values) => {
    console.log("Success:", values);
    updateData(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getData = async () => {
    try {
      console.log(user);
      const response = await dispatch(fetchOneUser(user.id)).unwrap();
      setData(response.data);
      setLoading(false);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    console.log("Mulai update dengan data:", values);
    const cleanedPayload = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v !== "")
    );
    try {
      await dispatch(
        updateUser({
          ...cleanedPayload,
          id: user.id,
        })
      ).unwrap();
      message.success("Update berhasil!");
      history.push("/app/settings");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    if (user?.id) {
      getData();
    }
  }, [user.id]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        username: data.username || "",
        email: data.email || "",
        no_phone: data.no_phone || "",
        isActive: "active" || "not active",
      });
    }
  }, [data, form]); // isi form saat data tersedia

  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 6 },
      lg: { span: 5 },
      xl: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 18 },
      lg: { span: 19 },
      xl: { span: 20 },
    },
  };

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Pengaturan</h2>

          <p>Atur data pengguna langsung</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              labelAlign="right"
              {...layout}
            >
              <Typography.Title level={5}>Profil Pengguna</Typography.Title>

              <Form.Item label="Username" name="username">
                <Input />
              </Form.Item>

              <Form.Item label="Email" name="email">
                <Input disabled />
              </Form.Item>

              <Form.Item label="Phone (WA)" name="no_phone">
                <Input />
              </Form.Item>

              <Divider />

              <Form.Item>
                <Typography.Title level={5}>Keamanan Pengguna</Typography.Title>
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please input your password!",
                //   },
                // ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Konfirmasi password tidak cocok!")
                      );
                    },
                  }),
                  //   {
                  //     required: true,
                  //     message: "Please input your password!",
                  //   },
                ]}
              >
                <Input.Password />
              </Form.Item>
              {/* <Form.Item label="Status" name="isActive">
                <Input disabled />
              </Form.Item> */}
              <Form.Item wrapperCol={24}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Update
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SETTINGS;
